export class BaseService {
    async post(model, url, success) {
        const token = localStorage.getItem('user-token') || '';
        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token,
            },
            body: JSON.stringify(model),
        };
        return await fetch(url, options)
            .then(async (response) => {
            if (response.status !== 200) {
                return {
                    success: false,
                    data: this.trim(await response.text()),
                    status: response.status,
                };
            }
            return {
                success: true,
                data: await response.json(),
                status: response.status,
            };
        })
            .catch((error) => {
            return {
                success: false,
                data: error,
                status: -1,
            };
        });
    }
    async get(url, success) {
        const token = localStorage.getItem('user-token') || '';
        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token,
            },
        };
        return await fetch(url, options)
            .then(async (response) => {
            switch (response.status) {
                case 200: {
                    return {
                        success: true,
                        data: await response.json(),
                        status: response.status,
                    };
                }
                case 401: {
                    // EventBus.$emit(GE_UNAUTHORIZED, false);
                    return {
                        success: false,
                        data: null,
                        status: response.status,
                    };
                }
                default: {
                    return {
                        success: false,
                        data: this.trim(await response.text()),
                        status: response.status,
                    };
                }
            }
        })
            .catch((error) => {
            return {
                success: false,
                data: error,
                status: -1,
            };
        });
    }
    trim(value) {
        if (value[0] === '"') {
            value = value.substring(1, value.length);
        }
        if (value[value.length - 1] === '"') {
            value = value.slice(0, value.length - 1);
        }
        return value;
    }
}
//# sourceMappingURL=base.service.js.map